/** Event category / subcategory / genre options (aligned with backend event.category enum). */

export const EVENT_CATEGORIES = [
  { value: "Music", label: "Music Shows" },
  { value: "Theatre", label: "Theatre" },
  { value: "Comedy", label: "Comedy Shows" },
  { value: "Dance", label: "Dance" },
  { value: "Sports", label: "Sports" },
  { value: "Exhibition", label: "Exhibition" },
  { value: "Festival", label: "Festival" },
  { value: "Conference", label: "Conference" },
  { value: "Workshop", label: "Workshop" },
  { value: "Corporate", label: "Corporate" },
];

export const EVENT_CATEGORY_VALUES = EVENT_CATEGORIES.map((c) => c.value);

/** Sub-categories keyed by category value */
export const EVENT_SUBCATEGORIES = {
  Music: ["Club Gigs", "Concerts", "Music Festivals", "Open Mic"],
  Theatre: ["Plays", "Musicals", "Drama", "Experimental"],
  Comedy: ["Stand-up", "Improv", "Open Mic", "Roast"],
  Dance: ["Classical", "Contemporary", "Folk", "Bollywood"],
  Sports: ["Matches", "Tournaments", "Fitness", "Esports"],
  Exhibition: ["Art", "Trade Show", "Expo", "Gallery"],
  Festival: ["Cultural", "Food & Drink", "Music Festival", "Film"],
  Conference: ["Summit", "Meetup", "Seminar", "Panel"],
  Workshop: ["Hands-on", "Masterclass", "Training", "Bootcamp"],
  Corporate: ["Private Event", "Brand Activation", "Offsite", "Launch"],
};

/** Genres keyed by category (BMS-style) */
export const EVENT_GENRES = {
  Music: [
    "A Cappella",
    "Acoustic",
    "Bollywood",
    "Classical",
    "EDM",
    "Folk",
    "Hip Hop",
    "Indie",
    "Jazz",
    "Pop",
    "Rock",
    "Sufi",
  ],
  Theatre: ["Comedy", "Drama", "Musical", "Tragedy", "Experimental"],
  Comedy: ["Dark Comedy", "Observational", "Political", "Roast", "Sketch"],
  Dance: ["Ballet", "Contemporary", "Folk", "Hip Hop", "Kathak", "Bollywood"],
  Sports: ["Action", "Adventure", "Competitive", "Recreational"],
  Exhibition: ["Art", "Design", "History", "Technology", "Fashion"],
  Festival: ["Culture", "Food", "Music", "Film", "Literature"],
  Conference: ["Business", "Tech", "Education", "Healthcare", "Startup"],
  Workshop: ["Creative", "Technical", "Career", "Wellness"],
  Corporate: ["Networking", "Product Launch", "Team Building", "Awards"],
};

export const EVENT_LANGUAGES = [
  "English",
  "Hindi",
  "Marathi",
  "Gujarati",
  "Tamil",
  "Telugu",
  "Kannada",
  "Malayalam",
  "Bengali",
  "Punjabi",
  "Urdu",
];

export const AGE_GROUP_OPTIONS = [
  { value: "0", label: "All age groups" },
  { value: "5", label: "5+" },
  { value: "12", label: "12+" },
  { value: "16", label: "16+" },
  { value: "18", label: "18+" },
  { value: "21", label: "21+" },
];

export const PERFORMER_ROLES = [
  "Artist",
  "Music Director",
  "Singer",
  "Band",
  "DJ",
  "Comedian",
  "Actor",
  "Dancer",
  "Speaker",
  "Host",
];

export const CREATE_EVENT_STEPS = [
  {
    id: "details",
    label: "Event Details",
    hint: "Name, categories and description",
  },
  {
    id: "additional",
    label: "Additional info",
    hint: "Terms, organizer and partners",
  },
  {
    id: "posters",
    label: "Event posters",
    hint: "Poster, gallery and layout",
  },
  {
    id: "venue",
    label: "Event Venue",
    hint: "Location and capacity",
  },
  {
    id: "schedule",
    label: "Event Schedule",
    hint: "Dates and showtimes",
  },
  {
    id: "tickets",
    label: "Event Tickets",
    hint: "Ticket types and pricing",
  },
];

export function categoryLabel(value) {
  return EVENT_CATEGORIES.find((c) => c.value === value)?.label || value || "";
}

export function subcategoriesFor(category) {
  if (!category) return [];
  return EVENT_SUBCATEGORIES[category] || [];
}

export function genresFor(category) {
  if (!category) return [];
  return EVENT_GENRES[category] || [];
}
